import {
  FaIdCard,
  FaPhoneAlt,
  FaBuilding,
  FaCreditCard,
  FaCheckCircle,
  FaCamera,
  FaUser,
  FaUsers,
  FaMapMarkerAlt,
  FaBolt,
  FaFileAlt,
  FaCar,
  FaShieldAlt,
  FaHistory,
} from "react-icons/fa";

const verificationConfig = {
  nin: {
    heroTitle: "Verify Your NIN",
    heroHighlight: "in seconds ",
    heroContinue: "",
    heroSubtitle:
      "Enter details, pay securely and get accurate results instantly.",
    heroImage: require("../../images/nin_verification_hero2.png"),
    breadcrumb: ["Verify Identity", "NIN Verification"],
    idTypeLabel: "National Identification Number (NIN)",
    fields: [
      {
        name: "nin",
        label: "NIN",
        placeholder: "Enter 11 digits NIN",
        type: "text",
        maxLength: 11,
        showCounter: true,
        required: true,
      },
    ],
    youWillGet: [
      { icon: FaUser, text: "Full personal details" },
      { icon: FaCamera, text: "Photo" },
      { icon: FaUsers, text: "Next of kin details" },
      { icon: FaCheckCircle, text: "Verification status" },
      { icon: FaBolt, text: "Instant results" },
    ],
    sampleResult: {
      name: "Grace Ojocheneimi David",
      identifier: "NIN: 43832856233",
      tags: ["Full Name", "Photo", "Date of Birth", "And more..."],
    },
    serviceName: "NIN Verification",
    serviceFieldKey: "nin",
    priceIndex: 0,
    requiresConsent: true,
    trustBar: [
      { title: "Secure & Private", desc: "Your data is protected" },
      { title: "Instant Results", desc: "Get results in seconds" },
      { title: "Trusted Platform", desc: "Consent compliant" },
      { title: "500,000+ Users", desc: "Trust e-citizen" },
    ],
  },

  phone: {
    heroTitle: "Verify a Phone Number ",
    heroHighlight: " in seconds",
    heroSubtitle:
      "Enter a phone number, pay securely and get verification results instantly.",
    heroImage: require("../../images/phone_number_verification.png"),
    breadcrumb: ["Verify Identity", "Phone Verification"],
    idTypeLabel: "Phone Number Verification",
    fields: [
      {
        name: "phone",
        label: "Phone Number",
        placeholder: "Enter phone number (e.g. 08031234567)",
        type: "text",
        maxLength: 11,
        showCounter: true,
        required: true,
      },
    ],
    youWillGet: [
      { icon: FaUser, text: "Owner information" },
      { icon: FaMapMarkerAlt, text: "Address details" },
      { icon: FaCheckCircle, text: "Date of Birth" },
      { icon: FaBolt, text: "Instant results" },
    ],
    sampleResult: {
      name: "Adebayo John O.",
      identifier: "Phone: 0803 *** 5678",
      tags: ["Owner Name", "Address", "Date of Birth", "And more..."],
    },
    serviceName: "Phone Verification",
    serviceFieldKey: "phone",
    priceIndex: 9,
    requiresConsent: true,
    trustBar: [
      { title: "Secure & Private", desc: "Your data is protected" },
      { title: "Instant Results", desc: "Get results in seconds" },
      { title: "Trusted Platform", desc: "Consent compliant" },
      { title: "500,000+ Users", desc: "Trust e-citizen" },
    ],
  },

  business: {
    heroTitle: "Verify a Business",
    heroHighlight: "in seconds",
    heroSubtitle:
      "Enter company details, pay securely and get accurate results instantly.",
    heroImage: require("../../images/business_verification2.png"),
    breadcrumb: ["Verify Business", "Business Verification"],
    idTypeLabel: "Business Registration (RC Number / Business Name)",
    fields: [
      {
        name: "business_name",
        label: "Business Name",
        placeholder: "Enter Business Name",
        type: "text",
        maxLength: 100,
        showCounter: false,
        required: false,
        eitherOr: "business",
      },
      {
        name: "rc",
        label: "RC Number",
        placeholder: "Enter RC Number",
        type: "text",
        maxLength: 10,
        showCounter: false,
        required: false,
        eitherOr: "business",
      },
    ],
    youWillGet: [
      { icon: FaBuilding, text: "Company details" },
      { icon: FaUsers, text: "Directors & shareholders" },
      { icon: FaFileAlt, text: "Registration status" },
      { icon: FaCheckCircle, text: "Verification status" },
      { icon: FaBolt, text: "Instant results" },
    ],
    sampleResult: {
      name: "ABC Technologies Ltd",
      identifier: "RC: 123456",
      tags: ["Company Name", "Directors", "Status", "And more..."],
    },
    serviceName: "Business Verification",
    serviceFieldKey: "rc",
    priceIndex: 2,
    trustBar: [
      { title: "Secure & Private", desc: "Your data is protected" },
      { title: "Instant Results", desc: "Get results in seconds" },
      { title: "Trusted Platform", desc: "Consent compliant" },
      { title: "500,000+ Users", desc: "Trust e-citizen" },
    ],
  },

  "business-name": {
    heroTitle: "Verify a Business",
    heroHighlight: "Name",
    heroSubtitle:
      "Search by business name, pay securely and get accurate results instantly.",
    heroImage: require("../../images/business_verification.png"),
    breadcrumb: ["Verify Business", "Business Name Verification"],
    idTypeLabel: "Business Name Search",
    fields: [
      {
        name: "business_name",
        label: "Business Name",
        placeholder: "Enter business name",
        type: "text",
        maxLength: 100,
        showCounter: false,
        required: true,
      },
      {
        name: "purpose",
        label: "Purpose (optional)",
        placeholder: "Select purpose",
        type: "select",
        required: false,
        options: [
          "Due Diligence",
          "Partnership Verification",
          "Investment Check",
          "Compliance",
          "Other",
        ],
      },
    ],
    youWillGet: [
      { icon: FaBuilding, text: "Company details" },
      { icon: FaUsers, text: "Directors & shareholders" },
      { icon: FaFileAlt, text: "Registration status" },
      { icon: FaCheckCircle, text: "Verification status" },
      { icon: FaBolt, text: "Instant results" },
    ],
    sampleResult: {
      name: "XYZ Enterprises",
      identifier: "BN: 3456789",
      tags: ["Business Name", "Directors", "Status", "And more..."],
    },
    serviceName: "Business Name Verification",
    serviceFieldKey: "business_name",
    priceIndex: 3,
    trustBar: [
      { title: "Secure & Private", desc: "Your data is protected" },
      { title: "Instant Results", desc: "Get results in seconds" },
      { title: "Trusted Platform", desc: "Consent compliant" },
      { title: "500,000+ Users", desc: "Trust e-citizen" },
    ],
  },

  bvn: {
    heroTitle: "Verify Your BVN ",
    heroHighlight: "in seconds",
    heroSubtitle:
      "Enter your BVN, pay securely and get financial verification results instantly.",
    heroImage: require("../../images/credit_profile.png"),
    breadcrumb: ["Verify Financial", "BVN Verification"],
    idTypeLabel: "Bank Verification Number (BVN)",
    fields: [
      {
        name: "bvn",
        label: "BVN",
        placeholder: "Enter 11 digits BVN",
        type: "text",
        maxLength: 11,
        showCounter: true,
        required: true,
      },
    ],
    youWillGet: [
      { icon: FaUser, text: "Full personal details" },
      { icon: FaCreditCard, text: "Financial profile" },
      { icon: FaCheckCircle, text: "Verification status" },
      { icon: FaBolt, text: "Instant results" },
    ],
    sampleResult: {
      name: "John Doe",
      identifier: "BVN: 22345678901",
      tags: ["Full Name", "Bank Details", "Status", "And more..."],
    },
    serviceName: "BVN Verification",
    serviceFieldKey: "bvn",
    priceIndex: 4,
    requiresConsent: true,
    bureaus: [
      { id: "crc", label: "Credit Risk Certification (CRC)", fieldName: "crc" },
      { id: "firstCentral", label: "First Central", fieldName: "firstCentral" },
      {
        id: "creditRegistry",
        label: "Credit Registry",
        fieldName: "creditRegistry",
      },
    ],
    allBureausDiscount: { ngn: 800, usd: 0.97 },
    trustBar: [
      { title: "Secure & Private", desc: "Your data is protected" },
      { title: "Instant Results", desc: "Get results in seconds" },
      { title: "Trusted Platform", desc: "Consent compliant" },
      { title: "500,000+ Users", desc: "Trust e-citizen" },
    ],
  },

  vehicle: {
    heroTitle: "Check Vehicle History",
    heroHighlight: " in seconds",
    heroSubtitle:
      "Verify a vehicle by VIN to reduce fraud and make safer purchase decisions.",
    heroImage: require("../../images/VIN_verification_platform_in_nigeria.png"),
    breadcrumb: ["Verify Vehicle", "Vehicle Verification"],
    idTypeLabel: "Vehicle Identification Number (VIN)",
    fields: [
      {
        name: "vin",
        label: "VIN (Vehicle Identification Number)",
        placeholder: "Enter VIN",
        type: "text",
        maxLength: 17,
        showCounter: true,
        required: true,
      },
    ],
    youWillGet: [
      { icon: FaCar, text: "Vehicle details" },
      { icon: FaHistory, text: "Ownership history" },
      { icon: FaShieldAlt, text: "Theft / watchlist status" },
      { icon: FaCheckCircle, text: "Verification status" },
      { icon: FaBolt, text: "Instant results" },
    ],
    sampleResult: {
      name: "Toyota Sienna 2018",
      identifier: "VIN: 47589065678",
      tags: ["Make/Model", "Ownership", "Status", "And more..."],
    },
    serviceName: "Vehicle Verification",
    serviceFieldKey: "vin",
    priceIndex: 5,
    trustBar: [
      { title: "Secure & Private", desc: "Your data is protected" },
      { title: "Instant Results", desc: "Get results in seconds" },
      { title: "Trusted Platform", desc: "Consent compliant" },
      { title: "500,000+ Users", desc: "Trust e-citizen" },
    ],
  },
};

export default verificationConfig;
